import { useFiltersContext } from '@/context'
import { DashboardQueries } from '@/graphql/queries/dashboard.queries'
import { HomeReadinessSectionData } from '@/types/Dashboard'

import { useGraphql } from '../useGraphql'

const useHomeReadinessSection = () => {
  const [{ marketSegmentFilter }] = useFiltersContext()
  const { marketSegmentIds } = marketSegmentFilter
  const homeReadinessQuery = useGraphql<{ agmDashboard: HomeReadinessSectionData }>(
    DashboardQueries.QUERY_KEYS.getHomeReadinessSection,
    DashboardQueries.getHomeReadinessSection(),
    {
      marketSegmentIds: marketSegmentIds,
    },
    {
      enabled: !!marketSegmentIds,
    },
  )

  return homeReadinessQuery
}

export default useHomeReadinessSection
